export default __webpack_public_path__ + "static/media/trr-food-pastry-12.29c22356.png";